module.exports = __webpack_public_path__ + "static/img/detail_pic4.db8adeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_pic4.png
// module id = QhmJ
// module chunks = 2